import { default as SiteModeLogo } from 'components/Shared/Logo';

interface OwnProps {
  className?: string;
}

export const Logo = ({ className }: OwnProps) => {
  return <SiteModeLogo wrapperClassName={className} />;
};
